module.exports = __webpack_public_path__ + "img/monster-banner.4c45b78a.png";